import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberSuffix'
})
export class NumberSuffixPipe implements PipeTransform {
    // eslint-disable-next-line complexity, max-statements
  transform(input: any): any {
     // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    if(input >= 1000 && input < 1000000){
       // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      return '$'+(input/1000) + 'K'; // convert to K for number from > 1000 < 1 million 
       // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  }else if(input >= 1000000 && input <1000000000){
     // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      return '$'+(input/1000000) + 'M'; // convert to M for number from > 1 million 
  }
   // eslint-disable-next-line @typescript-eslint/no-magic-numbers
else if(input >=1000000000 && input <1000000000000){
   // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  return '$'+(input/1000000000) + 'B'; // convert to B for number from > 1 Billion 
}
 // eslint-disable-next-line @typescript-eslint/no-magic-numbers
else if(input > 1000000000000)
{
   // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  return '$'+(input/1000000000000) + 'T';
}
 // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  else if(input < 1000){
     // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      return '$'+(input/1); // if value < 1000, nothing to do
  }
  else {
    return input
  }
  }
}
